import { Component, inject, signal } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
} from '@core/user-interface-legacy';
import { type AskHrDynamicFormConfig } from '@tellent-ask-hr/templates-smart-ui';
import type { AskTemplate } from '@tellent-ask-hr/templates-types';
import { TicketsDataService } from '@tellent-ask-hr/tickets-logic';
import type { CreateAskTicket } from '@tellent-ask-hr/tickets-types';

import { CreateTicketComponent } from '../create-ticket/create-ticket.component';

@Component({
  selector: 'ask-hr-create-ticket-dialog',
  template: `
    <rt-dialog-header
      [heading]="'tlc.ask_hr.requests.create.heading' | translate"
      [subheading]="'tlc.ask_hr.requests.create.subheading' | translate"
    />
    <rt-dialog-body layout-justify-center>
      <div class="dialog-body">
        <tlc-create-ticket
          #createTicketComponent
          [template]="dialogData.template"
          (ticketChanges)="ticketData.set($event)"
        />
      </div>
    </rt-dialog-body>
    <rt-dialog-footer>
      <rt-button (click)="dialogRef.close()">
        {{ 'tlc.ask_hr.requests.create.cancel' | translate }}
      </rt-button>
      <rt-button
        variant="primary"
        [disabled]="!createTicketComponent.isFormValid()"
        (click)="onSubmit()"
      >
        {{ 'tlc.ask_hr.requests.create.submit' | translate }}
      </rt-button>
    </rt-dialog-footer>
  `,
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    TranslatePipe,
    DialogFooterComponent,
    ButtonComponent,
    CreateTicketComponent,
    CreateTicketComponent,
  ],
  styleUrls: ['./create-ticket-dialog.component.less'],
})
export class CreateTicketDialogComponent extends DialogComponent<{ template: AskTemplate }, void> {
  private readonly ticketsDataService = inject(TicketsDataService);
  protected ticketData = signal<CreateAskTicket<AskHrDynamicFormConfig> | null>(null);

  public async onSubmit() {
    const ticketData = this.ticketData();
    if (!ticketData) return;

    const result = await firstValueFrom(this.ticketsDataService.createTicket(ticketData));
    if (result.isSuccess) {
      this.dialogRef.close();
    }
  }
}
